export const labelContainerTestId = 'jql-builder-basic.common.ui.format-label.label-container';
export const badgeTestId = 'jql-builder-basic.common.ui.format-label.badge';
